import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { TokenService } from '../services/token';
import { NotificationService } from '../services/notification';
import { AuthService } from '../services/auth';
import { NavigationService } from '../services/navigation';

export const jwtInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const tokenService = inject(TokenService);
  const authService = inject(AuthService);
  const notify = inject(NotificationService);
  const navigationService = inject(NavigationService);

  const token = tokenService.getToken();
  let authReq = req;

  // Skip adding token for auth endpoints to avoid circular calls
  if (isAuthEndpoint(req.url)) {
    return next(req);
  }

  if (token?.accessToken) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token.accessToken}`
      }
    });
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // // Skip refresh if already calling refresh endpoint
        // if (req.url.includes('/auth/refresh') || req.url.includes('/refresh-token')) {
        //   notify.show('Session expired. Please login again.', 'danger');
        //   handleAuthenticationFailure(tokenService, navigationService);
        //   return throwError(() => error);
        // }

        // const refreshToken = token?.refreshToken;
        // if (!refreshToken) {
        //   notify.show('Session expired. Please login again.', 'danger');
        //   handleAuthenticationFailure(tokenService, navigationService);
        //   return throwError(() => error);
        // }

        // // Attempt to refresh token
        // return authService.getNewAccessToken(refreshToken).pipe(
        //   switchMap((res) => {
        //     tokenService.setToken({
        //       accessToken: res.access_token,
        //       refreshToken: res.refresh_token || refreshToken, // Keep existing refresh token if not provided
        //       expiresIn: res.expires_in,
        //       tokenType: res.token_type
        //     });

        //     const newToken = tokenService.getToken();
        //     const retryReq = req.clone({
        //       setHeaders: {
        //         Authorization: `Bearer ${newToken?.accessToken}`
        //       }
        //     });
        //     return next(retryReq);
        //   }),
        //   catchError(refreshError => {
        //     notify.show('Session expired. Please login again.', 'danger');
        //     handleAuthenticationFailure(tokenService, navigationService);
        //     return throwError(() => refreshError);
        //   })
        // );
        notify.show('Session expired. Please login again.', 'danger');
        handleAuthenticationFailure(tokenService, navigationService);
        return throwError(() => error);
      }
      /*
        // Attempt to refresh token
        return authService.getNewAccessToken(refreshToken).pipe(
          switchMap((res) => {
            tokenService.setToken({
              accessToken: res.access_token,
              refreshToken: res.refresh_token || refreshToken, // Keep existing refresh token if not provided
              expiresIn: res.expires_in,
              tokenType: res.token_type
            });

            const newToken = tokenService.getToken();
            const retryReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${newToken?.accessToken}`
              }
            });
            return next(retryReq);
          }),
          catchError(refreshError => {
            notify.show('Session expired. Please login again.', 'danger');
            handleAuthenticationFailure(tokenService, navigationService);
            return throwError(() => refreshError);
          })
        );
      }
    */
      // Other errors
      return throwError(() => error);
    })
  );
};

function isAuthEndpoint(url: string): boolean {
  // Skip token addition for authentication endpoints
  const authEndpoints = [
    '/users/login',
    '/users/register', 
    '/accounts/auth/login',
    '/accounts/auth/refresh-token',
    '/accounts/auth/forgot-password',
    '/accounts/auth/reset-password',
    '/accounts/auth/verify-token'
  ];
  
  return authEndpoints.some(endpoint => url.includes(endpoint));
}

function handleAuthenticationFailure(tokenService: TokenService, navigationService: NavigationService): void {
  // Clear tokens and redirect to login
  tokenService.clearToken();
  navigationService.navigateTo('/auth/login');
}